/**
 * Firebird user tokens are 7-day JWTs. The SDK persists them in
 * localStorage, so a fan who signed in over a week ago still has one on
 * disk long after it stopped working — its presence alone is not evidence
 * of an active session.
 */

function decodePayload(token: string): Record<string, unknown> | null {
  const segments = token.split('.');
  if (segments.length !== 3) {
    return null;
  }
  try {
    const base64 = segments[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      '='
    );
    const decoded: unknown = JSON.parse(atob(padded));
    return typeof decoded === 'object' && decoded !== null
      ? (decoded as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

/**
 * Report whether a stored token's `exp` claim has passed.
 *
 * A token we cannot parse counts as expired: it can't authenticate
 * anything, so forcing a fresh sign-in is the useful outcome.
 */
export function isTokenExpired(token: string): boolean {
  const payload = decodePayload(token);
  if (!payload || typeof payload.exp !== 'number') {
    return true;
  }
  return payload.exp * 1000 <= Date.now();
}
